import StudentTracking from "../../../lms-shared/StudentStatistics/StudentTracking"
import { useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import classes from './StudentTrackingPage.module.css'

const StudentTrackingPage = () => {

    const { id, guid } = useParams();
    const { courses } = useSelector(state => state.courses);
    const applicationId = useSelector(state => state.application.applicationId);
    const [currentCourse, setCurrentCourse] = useState();

    useEffect(() => {
        const currentCoursesIndex = courses.findIndex(x => (x.id) === id);
        setCurrentCourse(courses[currentCoursesIndex])
    }, [id, courses, applicationId])

    return (
        <div className={classes.StudentTrackingPage}>
            <StudentTracking currentCourse={currentCourse} studyGroupId={id} userId={guid} id={id} />
        </div>
    )
}
export default StudentTrackingPage